import { LayoutZone } from "./layoutZone";

export class Layout {
  constructor(
    public id: string,
    public name: string,
    public zones: LayoutZone[],
  ) {}
  public get baseZone(): LayoutZone {
    return this.zones[0];
  }
}
